<template>
  <Modal title="Диапазон дат" @backdrop-click="close" class="modal">
    <template slot="body">
      <div class="modal__content_date-range">
        <span v-if="notice" class="content__notice">
          {{ notice }}
        </span>
        <div class="date-range">
          <label>Диапазон дат:</label>
          <Select
            class="input__field"
            :options="rangeTypes"
            :default-key="selectedType"
            @input="setType"
          />
        </div>
        <div class="alert alert-info content__alert_formatted-range">
          {{ alertLabel }}:
          <span v-if="selectedType === 'today'" class="alert-link">
            Начало и конец смены {{ formattedRange[0] }}
          </span>
          <div v-else-if="selectedType === 'custom_range'">
            <DatePicker
              type="date"
              placeholder="Укажите нужные даты"
              class="alert__datepicker"
              :lang="russianLocale"
              :popup-style="datepickerStyles"
              v-model="dates"
              range
              @clear="dates = []"
            />
          </div>
          <span v-else-if="selectedType === 'all_time'" class="alert-link">
            Все время работы
          </span>
          <span v-else class="alert-link">
            {{ formattedRange.join(' - ') }}
          </span>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            class="btn btn-danger close-btn buttons__button_close-modal"
            @click="close"
          >
            Выйти
          </button>
        </div>
        <div>
          <button
            class="btn btn-success"
            :disabled="submitWasDisabled"
            @click="save"
          >
            Применить
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import russianLocale from 'vue2-datepicker/locale/ru';

import Modal from "@/_shared/components/ui/Modal";
import Select from "@/_shared/components/ui/Select";

import { formats } from "@/_shared/constants";
import { date } from "@/_shared/utils";
export default {
  emits: [
    "save",
    "close",
  ],
  components: {
    Modal,
    Select,
    DatePicker,
  },
  props: {
    notice: {
      type: String,
    },
    initType: {
      type: String,
    },
    initDates: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      rangeTypes: {
        today: "Сегодня",
        current_week: "Эта неделя",
        current_month: "Этот месяц",
        last_month: "Прошлый месяц",
        current_year: "Этот год",
        all_time: "Все время",
        custom_range: "Другой",
      },
      selectedType: this.initType || 'all_time',
      dates: this.initDates,
      russianLocale,
    };
  },
  mounted() {
    document.querySelector("body").style.overflow = "hidden";
  },
  computed: {
    alertLabel() {
      if (this.selectedType === 'custom_range') {
        return 'Свой диапазон';
      }
      return 'Сформированный диапазон';
    },
    datepickerStyles() {
      const styles = {
        zIndex: '10000',
      };
      return styles;
    },
    submitWasDisabled() {
      return !!(this.selectedType === 'custom_range'
        && this.dates.length < 2);
    },
    formattedRange() {
      const [start, end] = this.dates;
      return [
        start.toLocaleString('ru', formats.dates.analytics),
        end.toLocaleString('ru', formats.dates.analytics),
      ];
    },
  },
  methods: {
    setType(value) {
      this.dates = [];
      this.selectedType = value;
      const rangeSetters = {
        today: () => date.getTodayRange(),
        current_month: () => date.getLastMonthRange(),
        current_year: () => date.getCurrentYearRange(),
        last_month: () => date.getPrevMonthRange(),
        current_week: () => date.getCurrentWeekRange(),
        all_time: () => date.getExistenceTimeRange(),
      };
      this.dates = rangeSetters[value]();
    },
    save() {
      this.$emit('save', this.dates, this.selectedType);
      this.close();
    },
    close() {
      document.querySelector("body").style.overflow = "auto";
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal__content_date-range,
.content__alert_formatted-range {
  display: flex;
  flex-direction: column;
}
.date-range {
  display: flex;
  flex-direction: column;
}
.content__alert_formatted-range span {
  max-width: 350px;
  padding-top: 0.5em;
  opacity: 1;
  cursor: default;
}
.content__alert_formatted-range {
  margin-top: 1.5em;
  margin-bottom: 0;
}
.input__field {
  width: 100%;
}
.content__notice {
  max-width: 300px;
  margin-bottom: 1em;
}
.alert__datepicker {
  padding-top: 1.2em;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/modals/DateRangeModal.vue